import { render } from "./Data.vue?vue&type=template&id=31b5bf4e"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jean/Desktop/Git-project/distell_invoice_backend_dist/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__